import {
  type AxiosRequestConfig,
  epHttpClient,
  googleAddressResponseToAddress,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';
import { publicEnv } from '@/config/public-env.config.mjs';

export interface GoogleAddressResponse {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: GeometryDetail;
  place_id: string;
  plus_code: PlusCode;
  types: string[];
  sessiontoken: string;
  fromCache: boolean;
  name: string;
}

export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface GeometryDetail {
  location: {
    lat: number;
    lng: number;
  };
  location_type: string;
  viewport: Viewport;
}
export interface Viewport {
  northeast: Location;
  southwest: Location;
}
export interface PlusCode {
  compound_code: string;
  global_code: string;
}

export interface GoogleAddressParams {
  place_id: string;
  sessiontoken?: string;
}

export const getGoogleAddressFn = async (
  params: GoogleAddressParams,
  config: AxiosRequestConfig = {}
) => {
  try {
    const response = await epHttpClient({
      apiURL: publicEnv.NEXT_PUBLIC_EP_API_URI,
      apiKey: publicEnv.NEXT_PUBLIC_EP_API_KEY,
    }).get<GoogleAddressResponse>(apiRoutes.place.detail, {
      params,
      ...config,
    });

    console.log('Raw Google Address Response:', response.data);

    if (!response.data?.geometry?.location) {
      console.error('Invalid response structure:', response.data);
      return null;
    }

    const processedAddress = googleAddressResponseToAddress(response.data);
    console.log('Processed Address Result:', processedAddress);

    if (!processedAddress) {
      // Fallback: create address object manually if googleAddressResponseToAddress returns null
      return {
        address: response.data.formatted_address || response.data.name,
        short_address: response.data.formatted_address,
        lat: response.data.geometry?.location?.lat,
        lng: response.data.geometry?.location?.lng,
        place_id: response.data.place_id,
        sessiontoken: params.sessiontoken ?? '',
      };
    }

    return processedAddress;
  } catch (error) {
    console.error('Error in getGoogleAddressFn:', error);
    return null; // Return null on error instead of throwing
  }
};
